import { ErrorStyled } from './styled'

export default function Error() {
    return (
        <ErrorStyled>
            <h2>Oops!</h2>
            <p>Página não encontrada</p>
        </ErrorStyled>
    )
}